<script setup lang="ts">
import { computed } from 'vue'
import Comment from './content.vue'

const props = defineProps<{
  show: boolean
  episodeId: number
  scriptId: number
}>()

const emit = defineEmits<{
  (e: 'update:show', value: boolean): void
}>()

const popupShow = computed({
  get: () => props.show,
  set: (value: boolean) => emit('update:show', value),
})
</script>

<template>
  <van-popup
    v-model:show="popupShow"
    position="bottom"
    :overlay-style="{ opacity: 0 }"
    round
    class="h-[80vh] rounded-t-[20px] bg-gray-900!"
  >
    <Comment :episode-id="episodeId" :script-id="scriptId" @close="popupShow = false" />
  </van-popup>
</template>
